import { AttachmentFile } from "../expenses/models/attachement-file.model";
import { OrganizationJobStructure } from "./lookups/organizationJobStructure.model";

export class User {
  // Note: Using only optional constructor properties without backing store disables typescript's type checking for the type
  constructor(id?: string, userName?: string, fullName?: string, email?: string, jobTitle?: string, phoneNumber?: string, profilePicFileId?: string, roles?: string[], rolesIds?: number[]) {

    this.id = id;
    this.userName = userName;
    this.fullName = fullName;
    this.email = email;
    this.jobTitle = jobTitle;
    this.phoneNumber = phoneNumber;
    this.roles = roles;
    this.rolesIds = rolesIds;
    this.profilePicFileId = profilePicFileId;
  }


  get friendlyName(): string {
    let name = this.fullName || this.userName;

    if (this.jobTitle)
      name = this.jobTitle + " " + name;

    return name;
  }


  public id: string;
  public userName: string;
  public fullName: string;
  public email: string;
  public jobTitle: string;
  public phoneNumber: string;
  public isEnabled: boolean;
  public isGpsEnabled: boolean;
  public isLockedOut: boolean;
  public roles: string[];
  public rolesIds: number[];
  public job: OrganizationJobStructure;
  public jobId?: number;
  public jobName: string;
  public hrCode: string;
  public hiringDate: Date;
  /** users list only: from the latest approved release form, else the latest pending one */
  public lastWorkingDay?: Date;
  public lastWorkingDayPending?: boolean;
  public disabledDate: Date;
  public profilePicFileId: string;
  public profilePicFile: AttachmentFile;
  public businessunitid: number;
  public creationDate?: Date;
  public lastWebLoginDate?: Date;
  public lastMobileLoginDate?: Date;
  public businessUnitName: string;
  public jobLinkedToOtherUser: boolean;
  public businessUnitsTree: string[];
  public carLicenseNo: string;
  public hasCar: boolean;
  public hasFullDashboard: boolean;
  /** Assigned equipment (type + unique serial number). */
  public equipments: { id: number, equipmentTypeId: number, equipmentTypeName?: string, serialNumber: string }[];
}
